export const PhoneRegex = new RegExp(/^[+]{0,1}[0-9 ]*$/);
